module.exports = __webpack_public_path__ + "static/flags/es-f1b84eaf8d798e6bb16f973ed0f8b1f3.svg";